import { Globals as OldGlobals } from '../../global/Globals';
import CheckboxDropDown from '../../components/CheckboxDropDown/CheckboxDropDown';
import { useProposalContext } from './ProposalHalfUnsolicated';
import {
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
    makeStyles
} from '@material-ui/core'
import Halfpageheader from '../HalfPageComponents/HalfPageHeader';
import ProposalDetails from '../HalfPageComponents/ProposalDetails';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { assignProposalSubmit } from '../../services/api';
import { evaluationCriteriaStyle } from '../../components/useStyles/useStyles';
import PopUp from '../../components/PopUp/PopUp';
import '../../components/HalfPageBrief/HalfPageBrief.css'
import { useLanguage } from '../../context/Languagecontext';
const useStyles = makeStyles(evaluationCriteriaStyle);
export const AssignProposalHalfPage = forwardRef((props, ref) => {
    const { Globals } = useLanguage();
    const classes = useStyles();
    const { proposalData,
        onClose,
        dropdownState,
        commissionEditior,
        handletog,
        handleSelectAll,
        handleSelect,
        dropdownRefs,
        evaluationVal,
        selectedCriteria,
        handleChange,
        optionalCriteriaNames,
        handleOptionlCriteriaName,
        removeOptionlCriteriaName,
        proposalId,
        addOptionlCriteriaName,
        refreshDashboard,
        renderToast,
        handleBackPress,
        setToBeAssigned
    } = useProposalContext();
    const error = {
        CommissionEditors: Globals.ASSIGN_PROPOSAL_ERROR.COMMISSION_EDITORS,
        EvaluationProcess: Globals.ASSIGN_PROPOSAL_ERROR.EVALUATION_PROCESS
    }
    const [errors, setErrors] = useState({});
    const [popup, setOpenPopup] = useState({state:'',isReject:''})
    const validateField1 = (fieldName, value) => {
        isButtonEnabled();
        if (!value?.length) {
            setErrors({ ...errors, [fieldName]: error[fieldName] });
            return false;
        } else {
            const newErrors = { ...errors };
            setErrors({ ...errors, [fieldName]: '' });
            delete newErrors[fieldName];
            setErrors(newErrors);
            return true;
        }

    };
    useImperativeHandle(ref, () => ({
        validateField1
    }));
    const [Evaluation, setEvaluation] = useState('')

    const handleEvaluationProcess = (e) => {

        const value = e?.target?.value
        setEvaluation(value)
        validateField1("EvaluationProcess", value)
    }
    const isButtonEnabled = () => {
        return (
            selectedCriteria.length && dropdownState.dropdowns.selected.length
        );

    };
    const [btnClassName, setBtnClassName] = useState("unsolicited-disabled-btn ");
    useEffect(() => {
        if (isButtonEnabled()) {
            setBtnClassName('unsolicited-ftr-register-btn-active')
        }
        else {
            setBtnClassName("unsolicited-disabled-btn ");
        }
    }, [isButtonEnabled()]);
    const assignProposal = () => {
        const AssignProposalBody = {
            "proposalId": proposalId,
            "commissioningEditorList": dropdownState.dropdowns.selected,
            "evaluationProcess": Evaluation,
            "evaluationCriteria": evaluationVal.filter(item => selectedCriteria.includes(item.criteriaName)),
            "customCriteria": optionalCriteriaNames,
        }

        assignProposalSubmit(AssignProposalBody)
            .then((response) => {
                if (response.data.status === "OK") {
                    onClose();
                    refreshDashboard();
                    renderToast("success", Globals.ASSIGN_PROPOSAL_TOAST_SUCCESS)
                } else {
                    renderToast("error", Globals.TOAST_FAILURE);
                }
            })
    }
    const openPopUp = () => {
        if(popup.isReject){
            return (

                <PopUp
                    title={Globals.ABORT_UNSOLICATED_PROPOSAL_TITLE}
                    text={Globals.ABORT_UNSOLICATED_PROPOSAL_MESSAGE}
                    negativeAction={onClose}
                    negativeActionText={Globals.ABORT_UNSOLICATED_BUTTON}
                    onClose={() => {
                        setOpenPopup({state:false})
                    }}
                />
    
    
            )
        }else{
            return (
            <PopUp
                    title={Globals.ASSIGN_PROPOSLS}
                    text={Globals.CE_POPUP_MESSAGE}
                    normalAction={assignProposal}
                    normalActionText={Globals.ASSIGN_PROPOSLS}
                    onClose={() => {
                        setOpenPopup({state:false})
                    }}
                />
            )
        }
        
    }
    return (
        <>
                <Halfpageheader handleBackPress={handleBackPress} setToBeAssigned={setToBeAssigned} headerValue={Globals.ASSIGN_PROPOSLS} onClose={() => setOpenPopup({state:false})} />
                    <div className='Header-half-screen-scroll'>
                    <div className="proposal-HalfPage-pitch1" >
                    <ProposalDetails expanded={true} />
                </div>
                <div className="proposal-HalfPage-pitch1">
                    <div className="proposal-title">
                        <div className="proposal-details">
                            <div style={{ display: "flex", paddingBottom: "30px" }}>
                                {Globals.CREATE_NEW_BRIEF.EVALUATION_INFORMATION}
                            </div>
                            <div className="Commission-Editor-Wrapper">
                                <label id="format-label" className="language">
                                    {Globals.COMMISSIONG_EDITORS}
                                    <span id="mandatory" className="mandatory">
                                        {Globals.MANDATORY_FIELD}
                                    </span>
                                </label>
                                <span className="Assign-Proposal-Commission-Editor-Dropdown">
                                    <CheckboxDropDown isOpen={dropdownState.activeDropdown} options={commissionEditior}
                                        onToggle={() =>
                                            handletog(dropdownState.activeDropdown)} onSelectAll={(selectAll, options) => handleSelectAll(selectAll, options)} onSelect={handleSelect} selectedValues={dropdownState.dropdowns.selected}
                                        title={Globals.SIGNUP.NAME_INP_PLACEHOLDER} selectedItems={dropdownState.dropdowns.selectedText}
                                        className={"dropdown-rejection"} isCreatedBy={true} outerDivClassName={`${dropdownState.dropdowns.selected.length && 'border-black'} rejectionDropdownSize`}
                                        longInputText={true} dropdownRef={(el) => (dropdownRefs.current["VirtualPitch"]
                                            = el)} fontColor={`${dropdownState.dropdowns.selected.length && `assign-dropdown-font-black`}`} />
                                    {errors.CommissionEditors && <div style={{ fontWeight: 400, marginBottom: "20px" }}><img src={OldGlobals.IMG.ERROR} alt="password error" /><span className="error">{errors.CommissionEditors}</span></div>}
                                </span>
                            </div>
                            <div>
                                <div className='Evaluation-Process-Wrapper'>
                                    <label id="location-studio-info-label" className="physical-address">
                                        {Globals.EVALUATION_PROCESS}
                                    </label>
                                    <textarea maxCharacters={1000} className="text-area Evaluation-Process-Text-Area"
                                        onBlur={(e) =>
                                            handleEvaluationProcess(e)} placeHolder={Globals.EVALUATION_INFORMATION_PLACEHOLDER}
                                        onChange={(e) => handleEvaluationProcess(e)} key={"location"} value={Evaluation}
                                        style={{
                                            borderColor: Evaluation && 'black', // Change border color based on value
                                            
                                          }}
                                        tabIndex="23" required maxLength={Globals.TXT_AREA_MAX_CHARS_LIMIT} />
                                        <div className="char-counter" style={{display:"flex"}}>
                                                  <div style={{flex:1}}>{Evaluation.length}/{Globals.TXT_AREA_MAX_CHARS_LIMIT}</div>  
                                                  </div>
                                </div>
                                <div className='Evaluation-Criteria-Wrapper'>
                                    <label id="location-studio-info-label" className="physical-address">
                                        {Globals.CREATE_NEW_BRIEF.EVALUATION_CRITERIA}
                                        <span id="mandatory" className="mandatory">
                                            {Globals.MANDATORY_FIELD}
                                        </span>
                                    </label>
                                </div>
                                <FormControl component="fieldset" className={classes.formControlRoot}>
                                    <FormGroup className={classes.formGroup}>
                                        {evaluationVal.map((item) => (
                                            <FormControlLabel classes={{
                                                root: classes.formLabelWrap, label: classes.formLabel
                                            }} key={item.criteriaId} control={<Checkbox checked={selectedCriteria.includes(item.criteriaName)}
                                                onChange={handleChange} name={item.criteriaName} 
                                                classes={{
                                                    root: classes.checkbox, checked: classes.checked
                                                }} />
                                            } label={item.criteriaName} />))}
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="proposal-HalfPage-pitch1">
                    <div className="proposal-title">
                        <div className="proposal-details">
                            <div style={{ display: "flex", paddingBottom: "10px" }}>
                                {Globals.CREATE_NEW_BRIEF.CRITERIA_NAME}
                            </div>
                        <div style={{ width: "350px" }}>
                            {optionalCriteriaNames.map((link, index) => (
                                <div
                                    key={index}
                                    className="social-media-link"
                                    style={{ marginBottom: "10px" }}
                                >
                                    <input
                                        value={link}
                                        type="url"
                                        id={`social-media-input-${index}`}
                                        className="social-media-inp titledDropdownSize"
                                        placeholder={Globals.CONTEXTUAL_REFERANCE}
                                        onChange={(event) => handleOptionlCriteriaName(index, event)}
                                        style={{
                                            width: "350px",
                                            border: link ? "1px solid black" : "1px solid #ccc", // Dynamically set border
                                        }}
                                        required
                                    />
                                    {index > 0 && (
                                        <button
                                            type="button"
                                            className="remove-social-link"
                                            onClick={() => removeOptionlCriteriaName(index)}
                                        />
                                    )}
                                </div>
                            ))}
                            {optionalCriteriaNames.length < 3 ? (
                                <button
                                    type="button"
                                    id="add-social-link"
                                    className="add-social-link-unsolicited"
                                    onClick={addOptionlCriteriaName}
                                >
                                    {Globals.ADD_MORE_CRITERIAN}
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    id="add-social-link-disabled"
                                    className="add-social-link-disabled"
                                    style={{ width: "150px" }}
                                    disabled={true}
                                >
                                    {Globals.ADD_MORE_CRITERIAN}
                                </button>
                            )}
                        </div>

                        </div>
                    </div>
                </div>
                    </div>

                <div id="register-footer" className="register-footer">
                    <div className="register-footer-btn-frame">
                        <div className="reg-footer-btn-group HalfPage-Assign-Page-Footer">
                            <span className="cancel-reg-btn" onClick={() => setOpenPopup({state:true,isReject:true})} >{Globals.SIGNUP.CANCEL}</span>
                            <button id="action-button " className={btnClassName} onClick={() => setOpenPopup({state:true,isReject:false})} >{Globals.ASSIGN_PROPOSLS}</button>
                        </div>
                        {popup.state && openPopUp()}
                    </div>
                </div>
        </>
    )
})